module.exports = __webpack_public_path__ + "img/sleeve cap length.68c57ef2.png";